const weeksArray = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
]

export function convertRemindCommand(state) {
  // initialStateの値を参考にしてここに変換処理を入れる
  const {
    toType,
    to,
    message,
    isRepeat,
    interval,
    weeks,
    month,
    day,
    date,
    time
  } = state
  const timeText = `${TimeWithZero(time.hour)}:${TimeWithZero(time.minute)}${time.ampm
    }`

  const toTypes = {
    channel: '#',
    member: '@'
  }
  const destination = toType === 'me' ? 'me' : toTypes[toType] + to
  const baseCommand = `/remind ${destination} "${message}" at ${timeText}`
  const weekText = getWeekText(weeks)

  if (isRepeat) {
    switch (interval) {
      case 'day':
        return `${baseCommand} everyday`
      case 'week':
        // 平日の場合
        if (isWeekDay(weeks)) {
          return `${baseCommand} on every weekday`
        }
        return `${baseCommand} on every ${weekText}`
      case 'otherWeek':
        return `${baseCommand} on every other ${weekText}`
      case 'month':
        return `${baseCommand} on ${day} every month`
      case 'year':
        const monthText = TimeWithZero(month)
        const dayText = TimeWithZero(day)
        return `${baseCommand} on ${monthText}-${dayText} every year`
      default:
        return ``
    }
  } else {
    return `${baseCommand} on ${date}`
  }
}

// 時間の先頭に0のprefixを付ける
function TimeWithZero(num, places = 2) {
  return String(num).padStart(places, '0')
}

// 先頭文字を大文字にする
function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

// 平日かどうか判定
function isWeekDay(weeks) {
  return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'].every(
    key => weeks[key]
  )
}

// カンマ区切りの週間の曜日を取得する
function getWeekText(weeks) {
  return weeksArray
    .filter(key => weeks[key])
    .map(v => capitalizeFirstLetter(v))
    .join(', ')
}
